/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    battery: {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M0 6a2 2 0 012-2h10a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2zm2-1a1 1 0 00-1 1v4a1 1 0 001 1h10a1 1 0 001-1V6a1 1 0 00-1-1zm14 3a1.5 1.5 0 01-1.5 1.5v-3A1.5 1.5 0 0116 8"/>',
    },
});
